import { FeatureFlag } from '@ps/web-core-enums';
import { select, useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import Alert from '../Alert/Alert';

import {
  TXTWCL_Important_information_about_yo_ELL,
  TXTWCL_Just_so_you_know,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_19,
  TXTWCL_To_get_things_back_up_and_runn_ELL_1,
  TXTWCL_To_reactivate_your_accountX_yo_ELL,
  TXTWCL_WeXve_had_to_suspend_your_acco_ELL,
  TXTWCL_WeXve_had_to_suspend_your_acco_ELL_2
} from './AMLSuspended.messages.json';
import { info } from './AMLSuspended.scss';

const AMLSuspended: React.FC = () => {
  const userId = useSelector(select.account.getUserId);
  const IDScanSDK = useFeature(FeatureFlag.IDScanSDK);

  const translations = {
    suspendMessage: IDScanSDK
      ? TXTWCL_WeXve_had_to_suspend_your_acco_ELL_2
      : TXTWCL_WeXve_had_to_suspend_your_acco_ELL,
    restrictionMessage: IDScanSDK
      ? TXTWCL_This_means_you_wonXt_be_able_t_ELL_19
      : TXTWCL_This_means_you_wonXt_be_able_t_ELL,
    reactivationMessage: IDScanSDK
      ? TXTWCL_To_reactivate_your_accountX_yo_ELL
      : TXTWCL_To_get_things_back_up_and_runn_ELL_1
  };

  return (
    <>
      <Translation
        tagName="h2"
        {...TXTWCL_Important_information_about_yo_ELL}
        values={{ 0: userId }}
      />
      <Translation tagName="span" {...translations.suspendMessage} />
      <Alert variant="error" className={info}>
        <Translation {...TXTWCL_Just_so_you_know} tagName="b" />
        <br />
        <Translation {...translations.restrictionMessage} />
      </Alert>
      <Translation tagName="p" {...translations.reactivationMessage} />
    </>
  );
};
export default AMLSuspended;
